import * as React from 'react';
import * as targetAudience from "./style.module.scss";
export const TargetAudience = () => {
  return (
    <section className={targetAudience.targetAudience}>
      <div className={'container'}>
        <h4 className={targetAudience.targetAudience__title}>Онлайн-тренинг для вас, если&nbsp;вы:</h4>
        <div className={targetAudience.targetAudience__wrap}>
          <div className={`${targetAudience.targetAudience__item} ${targetAudience.targetAudience__itemOne}`}>
            <span className={targetAudience.targetAudience__text}>только начали учить иностранный язык</span>
          </div>
          <div className={`${targetAudience.targetAudience__item} ${targetAudience.targetAudience__itemTwo}`}>
            <span className={targetAudience.targetAudience__text}>
              убеждены, что для результата необходимо потратить годы
            </span>
          </div>
          <div className={`${targetAudience.targetAudience__item} ${targetAudience.targetAudience__itemThree}`}>
            <span className={targetAudience.targetAudience__text}>
              в&nbsp;поиске методики быстрого и&nbsp;качественного обучения
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
